import { property, queryAssignedElements } from 'lit/decorators.js';
import {html, LitElement, TemplateResult} from 'lit';
import {Validator} from "@/components/validators/validators";
import {SbkCheckbox} from "@/components/checkbox/checkbox";
import {unsafeHTML} from "lit/directives/unsafe-html.js";

type Constructor<T> =
// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new (...args: any[]) => T;

export declare class FormValidationMixinInterface {
    invalid: boolean;
    annotation: string;
    slotItems?: Array<SbkCheckbox>;
    validatorMapper: {
        [key: string]: Validator
    }
    validationErrorTemplate(id: string): TemplateResult<1>;
    getValidators(): Validator[];
    handleErrors(validators: Validator[], inputValue: string): void;
}

export const FormValidationMixin = <T extends Constructor<LitElement>>(superClass: T) => {
    class FormValidationMixin extends superClass {

        @property({ type: Boolean, reflect: true })
        invalid = false;

        @property()
        annotation = '';

        @queryAssignedElements()
        slotItems?: Array<FormValidationMixin>;

        validatorMapper: {
            [key: string]: Validator
        } = {}

        validationErrorTemplate(id: string) {
            if (!this.annotation) {
                return '';
            }
            return html`
                <sbk-annotation id=${id} variant="error">${unsafeHTML(this.annotation)}</sbk-annotation>
        `;
        }
        getValidators() {
            const validators: Validator[] = [];
            if (super.classList) {
                super.classList.forEach((className: string) => {
                    const regex = RegExp('validate[a-zA-Z]+', 'g');
                    let match;
                    while ((match = regex.exec(className)) !== null) {
                        if (match && this.validatorMapper[match[0]] && !validators.includes(this.validatorMapper[match[0]])) {
                            validators.push(this.validatorMapper[match[0]])
                        }
                    }
                    const matchCustom = className.match(/custom\[([a-zA-Z]+)\]/)
                    if (matchCustom && matchCustom[1] !== undefined && this.validatorMapper[matchCustom[1]] && !validators.includes(this.validatorMapper[matchCustom[1]])) {
                        validators.push(this.validatorMapper[matchCustom[1]])
                    }
                    const matchMinCheckbox = className.match(/validate\[minCheckbox\[\d/)
                    if (matchMinCheckbox && this.validatorMapper['minCheckbox'] && !validators.includes(this.validatorMapper['minCheckbox'])) {
                        validators.push(this.validatorMapper['minCheckbox'])
                    }
                    if (/required/.test(className) && !validators.includes(this.validatorMapper['required'])) {
                        validators.push(this.validatorMapper['required'])
                    }
                })
            }
            if (super.hasAttribute('required') && !validators.includes(this.validatorMapper['required'])) {
                validators.push(this.validatorMapper['required'])
            }

            return validators;
        }

        handleErrors(validators: Validator[], inputValue: string) {
            const validationErrors: string[] = validators.map((validator: Validator) => {
                return validator.isValid(inputValue, this) ? '' : validator.getErrorMessage()
            }).filter(Boolean)
            this.invalid = validationErrors.length > 0
            this.annotation = validationErrors[0];
            this.slotItems?.forEach(slotItem => {
                slotItem.invalid = this.invalid
            });
        }
    }
    return FormValidationMixin as Constructor<FormValidationMixinInterface> & T;
}
